import { CadNextNotificationTypeEnumType } from '@mark43/cad-api';
import { useMemo } from 'react';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { eventNotificationDisplayNames } from './event-notifications';

export function useEventNotificationDisplayNames(): Record<
    CadNextNotificationTypeEnumType,
    string
> {
    const { primaryPoliceSubdivisionName } = useBootstrapState();
    return useMemo(() => {
        return {
            ...eventNotificationDisplayNames,
            BEAT: primaryPoliceSubdivisionName,
        };
    }, [primaryPoliceSubdivisionName]);
}
